import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
let currentUser = JSON.parse(localStorage.getItem("currentUser"));
class EditSuperintendent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      techSuperintendentInfo: {
        clientUserId: 0,
        clientId: 0,
        userRole: "superintendent",
        userName: "",
        email: "",
        telephone: "",
        modifiedBy: currentUser.name,
        isDeleted: false,
      },
      index: 0,
      techSuperintendentArray: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateTechSuperintendent = this.updateTechSuperintendent.bind(this);
    this.addTechSuperintendent = this.addTechSuperintendent.bind(this);
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
      // this.props.history.goBack();
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      techSuperintendentList,
      techSuperintendentDetail,
      dispatch,
    } = nextProps;
    if (techSuperintendentDetail) {
      prevState.techSuperintendentInfo.clientUserId =
        techSuperintendentDetail.clientUserId;
      prevState.techSuperintendentInfo.clientId =
        techSuperintendentDetail.clientId;
      prevState.techSuperintendentInfo.userName =
        techSuperintendentDetail.userName;
      prevState.techSuperintendentInfo.email = techSuperintendentDetail.email;
      prevState.techSuperintendentInfo.telephone =
        techSuperintendentDetail.telephone;
      prevState.index = techSuperintendentList.findIndex(
        (x) => x.email === techSuperintendentDetail.email
      );
      dispatch({ type: "techSuperintendentDetail", data: null });
    }
    if (techSuperintendentList) {
      prevState.techSuperintendentArray = techSuperintendentList;
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "telephone") {
      const phone = e.target.validity.valid
        ? e.target.value
        : this.state.techSuperintendentInfo.telephone;
      this.state.techSuperintendentInfo[nodeName] = phone;
      this.setState({});
    } else {
      this.state.techSuperintendentInfo[nodeName] = e.target.value;
      this.setState({});
    }
  }

  addTechSuperintendent() {
    const { dispatch, match,t } = this.props;
    const { params } = match;
    const { id } = params;
    let userArray = [];
    let superintendent = {
      clientId: id,
      userRole: "superintendent",
      userName: this.state.techSuperintendentInfo.userName,
      email: this.state.techSuperintendentInfo.email,
      telephone: this.state.techSuperintendentInfo.telephone,
      createdBy: currentUser.name,
    };
    userArray.push(superintendent);
    if (this.state.techSuperintendentInfo.email !== "") {
      let url2 = `${API.userExist}?Mail=${this.state.techSuperintendentInfo.email}`;
      axios
        .get(url2, {
          headers: {
            key: currentUser.accessToken,
          },
        })
        .then((response) => {
          if (response.data === true) {
            let url = `${API.postClientuser}`;
            axios
              .post(url, userArray, {
                headers: {
                  key: currentUser.accessToken,
                },
              })
              .then((response) => {
                let url = `${API.getClientUsers}?clientId=${id}`;
                axios
                  .get(url)
                  .then((response) => {
                    let fleetManager =
                      response.data &&
                      response.data.filter((r) => r.role === "fleetmanager");
                    let techSuperintendent =
                      response.data &&
                      response.data.filter((r) => r.role === "superintendent");
                    let techExecutive =
                      response.data &&
                      response.data.filter(
                        (r) => r.role === "technicalexecutive"
                      );
                    dispatch({
                      type: "fleetManagerListSuccess",
                      data: fleetManager,
                    });
                    dispatch({
                      type: "techSuperintendentListSuccess",
                      data: techSuperintendent,
                    });
                    dispatch({
                      type: "techExecutiveListSuccess",
                      data: techExecutive,
                    });
                    dispatch({
                      type: "getClientUsersDetailsSuccess",
                      data: response.data,
                    });
                  })
                  .catch((error) => {
                    dispatch({
                      type: "getClientUsersDetailsFailure",
                      error: "ERROR",
                    });
                  });
                this.hideSidePanel();
                dispatch({
                  type: "postClientUserDetailSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "postClientUserDetailFailure",
                  error: "ERROR",
                });
              });
          } else if (response.data === false) {
            swal(
              "Error!",
              `${t("ShipManagementContent.UserWaringMsg")}`,
              "warning"
            );
            this.state.techSuperintendentInfo.email = "";
            this.setState({});
          }
          dispatch({
            type: "getUserExistListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getUserExistListFailure",
            data: "error",
          });
        });
    } else {
      swal("Error!", `${t("MMPLUserManagementContent.Emailismandatory")}`, "warning");
    }
  }

  updateTechSuperintendent() {
    const { techSuperintendentInfo, index } = this.state;
    this.state.techSuperintendentArray[index] = techSuperintendentInfo;
    this.setState({});
    this.props.dispatch({
      type: "techSuperintendentListSuccess",
      data: this.state.techSuperintendentArray,
    });
    this.hideSidePanel();
  }

  hideSidePanel() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  }

  render() {
    const { EditUser,t } = this.props;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="w-100">
            <div className="panel-box search-filter-box">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.hideSidePanel()}
              >
                &larr; {t("CommonText.Return")}
              </button>
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {t("ClientManagementScreenContent.TechnicalSuperintendents")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-6">
                  <label className="form-label">{t("EquipmentManagementScreenContent.Name")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="userName"
                    value={this.state.techSuperintendentInfo.userName}
                    placeholder={t("EquipmentManagementScreenContent.Name")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-6">
                  <label className="form-label">{t("ServicedByScreenContent.Email")}</label>
                  <br></br>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={this.state.techSuperintendentInfo.email}
                    placeholder={t("ServicedByScreenContent.Email")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-6">
                  <label className="form-label">{t("ClientManagementScreenContent.Phone")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    pattern="[0-9]*"
                    name="telephone"
                    value={this.state.techSuperintendentInfo.telephone}
                    placeholder={t("ClientManagementScreenContent.Phone")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    {!EditUser ? (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.addTechSuperintendent()}
                      >
                        {" "}
                        {t("ShipManagementContent.Add")}{" "}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.updateTechSuperintendent()}
                      >
                        {" "}
                        {t("EquipmentServiceTypes.Update")}{" "}
                      </button>
                    )}
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    techSuperintendentList: state.MasterScreenReducer.techSuperintendentList,
    techSuperintendentDetail:
      state.MasterScreenReducer.techSuperintendentDetail,
    EditUser: state.MasterScreenReducer.EditUser,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditSuperintendent)));
